.section {
    margin-bottom: 40px;
}

.fieldContainer {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    max-width: 420px;
}
